"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeaDeferredScript = exports.TeaScript = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const atom_1 = require("../../atom");
const jotai_1 = require("jotai");
const constant_1 = require("./constant");
const TEA_SCRIPT = `
(function(win, export_obj) {
  win['LogAnalyticsObject'] = export_obj;
  if (!win[export_obj]) {
      function _collect() {
          _collect.q.push(arguments);
      }
      _collect.q = _collect.q || [];
      win[export_obj] = _collect;
  }
  win[export_obj].l = +new Date();
})(window, 'Tea');
`.trim();
const configFilterEvent = (versions) => {
    window.Tea('filterEvent', (eventData) => {
        for (let i = 0; i < eventData.length; i++) {
            const events = eventData[i].events;
            for (let j = 0; j < events.length; j++) {
                events[j].ab_sdk_version = versions;
            }
        }
        return eventData;
    });
};
const TeaScript = () => {
    const { wapId } = (0, jotai_1.useAtomValue)(atom_1.$AppIdConfig);
    const { webId } = (0, jotai_1.useAtomValue)(atom_1.$WebUser);
    const { region, language, ipRegion } = (0, jotai_1.useAtomValue)(atom_1.$Locale);
    const { isMobile, isBot } = (0, jotai_1.useAtomValue)(atom_1.$UserAgent);
    const { trafficPid, trafficCampaign, enterPageName, enterPageUUID, enterPageId, logId } = (0, jotai_1.useAtomValue)(atom_1.$RootTraffic);
    const { versions } = (0, jotai_1.useAtomValue)(atom_1.$ABTest);
    const { disableInlineScripts } = (0, jotai_1.useAtomValue)(atom_1.$RenderConfig);
    const additionalScripts = (0, jotai_1.useAtomValue)(atom_1.$AdditionalScripts);
    (0, react_1.useMemo)(() => {
        if (__BUILD_TARGET__ !== 'client') {
            return;
        }
        if (!enterPageName) {
            console.error('no enterPageName in $RootTraffic');
        }
        const { Tea } = window;
        Tea('init', {
            app_id: wapId,
            channel: constant_1.TeaChannelMap[__BUILD_REGION__],
            channel_type: wapId === 580072 ? constant_1.TeaChannelTypeMap[__BUILD_REGION__] : void 0,
            channel_domain: wapId === 580072 ? constant_1.TeaChannelDomainMap[__BUILD_REGION__] : void 0,
            enable_cookie: false,
            // stay_duration,
            enable_stay_duration: {
                params: {
                    traffic_type: trafficPid,
                    traffic_campaign: trafficCampaign,
                    region,
                    enter_page_name: enterPageName,
                },
            },
        });
        Tea('config', {
            user_id: webId,
            web_id: webId,
            user_unique_id: webId,
            region,
            language,
            user_type: 12,
            // headers
            host: location.host,
            ip_region: ipRegion,
            seo_page_id: enterPageUUID,
            // common params
            evtParams: {
                is_bot: isBot ? 1 : 0,
                is_mobile: isMobile ? 1 : 0,
                traffic_type: trafficPid,
                language,
                enter_page_name: enterPageName,
                enter_page_id: enterPageId,
                log_id: logId,
            },
            ab_version: versions,
            ab_sdk_version: versions,
        });
        configFilterEvent(versions);
        Tea('start');
    }, []);
    (0, react_1.useEffect)(() => {
        configFilterEvent(versions);
    }, [versions]);
    if (disableInlineScripts) {
        return (0, jsx_runtime_1.jsx)("script", { id: "tea-script", src: additionalScripts['tea-precollect'] });
    }
    return (0, jsx_runtime_1.jsx)("script", { id: "tea-script", dangerouslySetInnerHTML: { __html: TEA_SCRIPT } });
};
exports.TeaScript = TeaScript;
const TeaDeferredScript = () => {
    return (0, jsx_runtime_1.jsx)("script", { id: "tea-script-defer", defer: true, src: constant_1.TeaScriptAsyncSrc[__BUILD_REGION__] });
};
exports.TeaDeferredScript = TeaDeferredScript;
